export default {
    /**
     * The system name of the barcode printer
     */
    barcodePrinter: 'barcode',

    /**
     * The system name of the zebra printer
     */
    zebraPrinter: 'zebra',

    /**
     * The system name of the letter printer
     */
    letterPrinter: 'letter',

    /**
     * The system name of the fedex printer
     */
    fedexPrinter: 'fedex',

    /**
     * The system name of the usps printer
     */
    uspsPrinter: 'usps',

    /**
     * The print options to send with the job
     */
    printOptions: {
        copies: 1,
        duplex: true
    },
};
